// src/pages/research/focusarea.js
import React from 'react';
import Header from '../homepage/header'; // import header
import './Focusarea.css'; // Optional CSS file for styling

const FocusArea = () => {
  return (
    <div>
      <Header /> {/* Include the Header component */}
    <div className="focus-area-container">
      <h1 className="focus-area-title">Focus Area</h1>

      <section className="focus-area-section">
        <h2>Network Security</h2>
        <p>
          In an era of digital transformation, securing network infrastructure is paramount. Our network security research focuses on designing and implementing resilient communication systems that safeguard sensitive information and prevent cyberattacks. We explore advanced encryption techniques, intrusion detection systems, and threat mitigation strategies to ensure the integrity and availability of network services.
        </p>
      </section>

      <section className="focus-area-section">
        <h2>Cryptography</h2>
        <p>
          Cryptography forms the backbone of secure communication and data protection. Our research in cryptography involves developing advanced algorithms and protocols to secure data transmission, authentication, and digital signatures. We aim to enhance the security of online transactions, cloud computing, and IoT systems by focusing on encryption, key management, and cryptographic standards.
        </p>
      </section>

      <section className="focus-area-section">
        <h2>Internet of Things (IoT) Security</h2>
        <p>
          As IoT devices become integral to daily life, ensuring their security is crucial. Our IoT security research focuses on safeguarding connected devices from unauthorized access, data breaches, and cyberattacks. We explore innovative techniques such as secure communication protocols, identity management, and anomaly detection to enhance the security of IoT ecosystems across industries like healthcare, smart cities, and agriculture.
        </p>
      </section>

      <section className="focus-area-section">
        <h2>Cyber-Physical Systems</h2>
        <p>
          Cyber-physical systems (CPS) combine physical processes with digital computing to manage critical infrastructure and industrial applications. Our research in CPS security aims to protect these systems from cyberattacks that could disrupt operations in sectors such as energy, manufacturing, transportation, and healthcare. We focus on securing real-time data exchanges, controlling critical systems, and preventing vulnerabilities that could lead to catastrophic consequences.
        </p>
      </section>

      <section className="focus-area-section">
        <h2>Digital Twin Technology</h2>
        <p>
          Digital twin technology allows the creation of virtual replicas of physical assets, processes, or systems to simulate real-world conditions and predict future behaviors. In cyber security, digital twins can be used to monitor and analyze security threats in real-time. Our research explores how digital twins can enhance threat detection, improve risk management, and create smarter, more resilient systems by integrating cyber security measures into the virtual models.
        </p>
      </section>

      <section className="focus-area-section">
        <h2>Data Privacy</h2>
        <p>
          Data privacy has become a key concern as personal and organizational data is increasingly being stored and shared across digital platforms. Our research in data privacy focuses on developing advanced privacy-preserving techniques, such as differential privacy, homomorphic encryption, and secure data sharing protocols. We work towards ensuring that individuals and organizations can trust digital systems with their sensitive data while complying with global privacy regulations.
        </p>
      </section>
    </div>
  </div>
  );
};

export default FocusArea;
